import {
  InstrumentWithWatchlist,
  Instrument
} from '@/modules/trade/services/instruments';
import { ObservableSubscription } from '@apollo/client/utilities/observables/Observable';
import { ISubscription } from '@/modules/trade/services/subscription';
import { EventsProvisionedList } from '@/modules/trade/views/TradeView/components/TradeSidebar/types';
import { CustomOperationSummary } from '@/modules/trade/services/custom-operations';
import { NumberFormatted } from '@/modules/trade/types';

export enum RequestStatus {
  Loading = 'loading',
  Error = 'error',
  Default = 'default'
}

export interface TradeState {
  positions: Instrument[];
  positionsUpdatedAt: NumberFormatted;
  watchlist: InstrumentWithWatchlist[];
  subscriptionList: ISubscription[];
  eventsProvisionedList: EventsProvisionedList;
  customOperations: CustomOperationSummary[];
  positionSubscription: ObservableSubscription | null;
}
